/* Helpers to flatten a referral tree into a list of rows (depth-first, with level) */
export function flattenRefTree(tree) {
    const rows = [];
    const walk = (nodes, level) => {
        for (const n of nodes) {
            rows.push({
                id: n.id,
                username: n.username,
                avatar_url: n.avatar_url,
                points_balance: n.points_balance,
                level,
            });
            if (n.children && n.children.length > 0) {
                walk(n.children, level + 1);
            }
        }
    };
    walk(tree || [], 1);
    return rows;
}
